import { render, staticRenderFns } from "./aktivenFunktionEditor.vue?vue&type=template&id=31fda786&"
import script from "./aktivenFunktionEditor.vue?vue&type=script&lang=js&"
export * from "./aktivenFunktionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports